// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../projects/ProjectsPage.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentCommitmentsPageMetaDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DevelopmentCommitmentsPageMetaDataQuery = { __typename?: 'Query', commitmentStatuses: Array<{ __typename?: 'CommitmentStatusDetail', code: Types.CommitmentStatus, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type DevelopmentCommitmentsPageQueryVariables = Types.Exact<{
  filter: Types.DevelopmentCommitmentFilter;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type DevelopmentCommitmentsPageQuery = { __typename?: 'Query', developmentCommitmentsPage: { __typename?: 'DevelopmentCommitmentsPage', entities: Array<{ __typename?: 'DevelopmentCommitment', id: string, committedInCents: number, createdAt: Types.Scalars['DateTime']['input'], executionDate?: Types.Scalars['Date']['input'] | null | undefined, name: string, updatedAt: Types.Scalars['DateTime']['input'], costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }>, market: { __typename?: 'Market', id: string, name: string }, statusDetail: { __typename?: 'CommitmentStatusDetail', code: Types.CommitmentStatus, name: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type DevelopmentCommitmentsPageDevCommFragment = { __typename?: 'DevelopmentCommitment', id: string, committedInCents: number, createdAt: Types.Scalars['DateTime']['input'], executionDate?: Types.Scalars['Date']['input'] | null | undefined, name: string, updatedAt: Types.Scalars['DateTime']['input'], costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }>, market: { __typename?: 'Market', id: string, name: string }, statusDetail: { __typename?: 'CommitmentStatusDetail', code: Types.CommitmentStatus, name: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined };

export const DevelopmentCommitmentsPageDevCommFragmentDoc = gql`
    fragment DevelopmentCommitmentsPageDevComm on DevelopmentCommitment {
  id
  committedInCents
  costCodes {
    id
    number
  }
  createdAt
  executionDate
  name
  market {
    id
    name
  }
  updatedAt
  statusDetail {
    code
    name
  }
  tradePartner {
    id
    name
  }
}
    `;
export const DevelopmentCommitmentsPageMetaDataDocument = gql`
    query DevelopmentCommitmentsPageMetaData {
  commitmentStatuses {
    code
    name
  }
  markets {
    id
    name
  }
}
    `;

/**
 * __useDevelopmentCommitmentsPageMetaDataQuery__
 *
 * To run a query within a React component, call `useDevelopmentCommitmentsPageMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentCommitmentsPageMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentCommitmentsPageMetaDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevelopmentCommitmentsPageMetaDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DevelopmentCommitmentsPageMetaDataQuery, DevelopmentCommitmentsPageMetaDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentCommitmentsPageMetaDataQuery, DevelopmentCommitmentsPageMetaDataQueryVariables>(DevelopmentCommitmentsPageMetaDataDocument, options);
      }
export function useDevelopmentCommitmentsPageMetaDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentCommitmentsPageMetaDataQuery, DevelopmentCommitmentsPageMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentCommitmentsPageMetaDataQuery, DevelopmentCommitmentsPageMetaDataQueryVariables>(DevelopmentCommitmentsPageMetaDataDocument, options);
        }
export function useDevelopmentCommitmentsPageMetaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentsPageMetaDataQuery, DevelopmentCommitmentsPageMetaDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentCommitmentsPageMetaDataQuery, DevelopmentCommitmentsPageMetaDataQueryVariables>(DevelopmentCommitmentsPageMetaDataDocument, options);
        }
export type DevelopmentCommitmentsPageMetaDataQueryHookResult = ReturnType<typeof useDevelopmentCommitmentsPageMetaDataQuery>;
export type DevelopmentCommitmentsPageMetaDataLazyQueryHookResult = ReturnType<typeof useDevelopmentCommitmentsPageMetaDataLazyQuery>;
export type DevelopmentCommitmentsPageMetaDataSuspenseQueryHookResult = ReturnType<typeof useDevelopmentCommitmentsPageMetaDataSuspenseQuery>;
export type DevelopmentCommitmentsPageMetaDataQueryResult = Apollo.QueryResult<DevelopmentCommitmentsPageMetaDataQuery, DevelopmentCommitmentsPageMetaDataQueryVariables>;
export const DevelopmentCommitmentsPageDocument = gql`
    query DevelopmentCommitmentsPage($filter: DevelopmentCommitmentFilter!, $page: PageFilter) {
  developmentCommitmentsPage(filter: $filter, page: $page) {
    entities {
      ...DevelopmentCommitmentsPageDevComm
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${DevelopmentCommitmentsPageDevCommFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useDevelopmentCommitmentsPageQuery__
 *
 * To run a query within a React component, call `useDevelopmentCommitmentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentCommitmentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentCommitmentsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDevelopmentCommitmentsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentCommitmentsPageQuery, DevelopmentCommitmentsPageQueryVariables> & ({ variables: DevelopmentCommitmentsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentCommitmentsPageQuery, DevelopmentCommitmentsPageQueryVariables>(DevelopmentCommitmentsPageDocument, options);
      }
export function useDevelopmentCommitmentsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentCommitmentsPageQuery, DevelopmentCommitmentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentCommitmentsPageQuery, DevelopmentCommitmentsPageQueryVariables>(DevelopmentCommitmentsPageDocument, options);
        }
export function useDevelopmentCommitmentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentsPageQuery, DevelopmentCommitmentsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentCommitmentsPageQuery, DevelopmentCommitmentsPageQueryVariables>(DevelopmentCommitmentsPageDocument, options);
        }
export type DevelopmentCommitmentsPageQueryHookResult = ReturnType<typeof useDevelopmentCommitmentsPageQuery>;
export type DevelopmentCommitmentsPageLazyQueryHookResult = ReturnType<typeof useDevelopmentCommitmentsPageLazyQuery>;
export type DevelopmentCommitmentsPageSuspenseQueryHookResult = ReturnType<typeof useDevelopmentCommitmentsPageSuspenseQuery>;
export type DevelopmentCommitmentsPageQueryResult = Apollo.QueryResult<DevelopmentCommitmentsPageQuery, DevelopmentCommitmentsPageQueryVariables>;